import { IconButton, makeStyles, Toolbar, useMediaQuery, useTheme } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import { PageTitle } from './PageTitle';
import { UserProfile } from '../../../models';
import identifiers from '../../../tests/identifiers';
import { Menus } from '../menu/Menus';
import { dividerColor } from 'src/data/colors';

export interface MainToolbarProps {
  profile: UserProfile;
  siteId: number;
  toggleNav: () => void;
}

export const MainToolbar = ({ profile, siteId, toggleNav }: MainToolbarProps) => {
  const classes = useStyles();
  const theme = useTheme();

  // TODO: Figure out how to retrieve customerId that doesn't require pulling the full site.

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Toolbar className={`${isSmallScreen && classes.rootMobile} ${classes.container}`}>
      {isSmallScreen && (
        <IconButton
          className={classes.toggleNavButton}
          data-testid={identifiers.mainNavigation.toggleNavMobile}
          onClick={toggleNav}
        >
          <MenuIcon className={classes.toggleNavIcon} />
        </IconButton>
      )}

      <PageTitle siteName={profile.sites.find((site) => site.siteId === siteId)?.siteName} />

      <Menus profile={profile} siteId={siteId} />
    </Toolbar>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    borderBottom: `1px solid ${dividerColor}`,
  },
  rootMobile: {
    backgroundColor: '#080B27',
  },
  toggleNavButton: {
    marginBottom: -3,
    marginLeft: -theme.spacing(0.5),
    marginRight: theme.spacing(1),
    marginTop: -3,
  },
  toggleNavIcon: {
    position: 'absolute',
    top: 0,
    left: 0,
    color: 'white',
    fontSize: '0.75em',
  },
}));
